export default "__VITE_ASSET__CPHcZByO__"